import type { NsDict } from '../ru';

export const profile: NsDict<'profile'> = {
  loading: 'Profil wird geladen…',
  'crumb.admin': 'Administration',
  'crumb.users': 'Benutzer',
  'tab.stats': 'Statistik',
  'tab.games': 'Spiele · {n}',
  'tab.settings': 'Einstellungen',
  'tag.banned': 'gesperrt',
  'tag.online': 'online',
  since: 'Dabei seit {date} · zuletzt aktiv {seen}',
  seenNow: 'jetzt',
  'method.login': 'Benutzername {login}',
  bannedAt: 'Gesperrt {date}',
  bannedAtReason: 'Gesperrt {date}: {reason}',
  balance: 'Guthaben',
  ban: 'Sperren',
  unban: 'Entsperren',
  'ban.title': '{name} sperren',
  'ban.text': 'Der Spieler wird vom Spiel getrennt und kann sich nicht mehr anmelden. In einem laufenden Spiel läuft sein Zug per Zeitüberschreitung ab; der Platz wird nach dem Spiel frei.',
  'ban.reason': 'Grund (für den Spieler sichtbar)',
  'ban.placeholder': 'z. B. Regelverstoß',

  'stats.summary': 'Übersicht',
  'stats.games': 'Spiele',
  'stats.gamesHint': 'davon abgebrochen: {n}',
  'stats.winRate': 'Gewinnquote',
  'stats.winRateHint': 'Anteil der Spiele mit Auszahlung unter den abgeschlossenen',
  'stats.net': 'Nettoergebnis',
  'stats.netHint': 'Summe der Nettoergebnisse, Cr',
  'stats.bestWin': 'Höchster Gewinn',
  'stats.correctDirection': 'Richtige Richtung',
  'stats.avgError': 'Durchschnittlicher Fehler',
  'stats.avgErrorHint': 'bei richtiger Richtung',
  'stats.pointsValue': '{v} Pkt.',
  'stats.folds': 'Folds',
  'stats.restores': 'Guthaben-Resets',
  'stats.restoresHint': 'wie oft das Guthaben auf den Startwert zurückgesetzt wurde',
  'stats.daily': 'Ergebnis nach Tagen',
  'stats.dailyLabel': 'Nettoergebnis nach Tagen',
  'stats.dailyNote': 'Letzter {n} Tag mit Spielen. Fahren Sie über eine Säule, um den Betrag zu sehen.|Letzte {n} Tage mit Spielen. Fahren Sie über eine Säule, um den Betrag zu sehen.',

  'settings.visibility': 'Sichtbarkeit am Tisch',
  'settings.statsShown': 'Gewinnquote und Nettoergebnis sind am Tisch sichtbar',
  'settings.statsHidden': 'Statistik ausgeblendet',
  'settings.showStats': 'Gewinnquote und Nettoergebnis auf meinem Namensschild anzeigen',
  'settings.showStatsNote': 'Andere Spieler sehen sie neben Ihrem Namen in der Teilnehmerliste.',
  'settings.winRateTitle': 'Gewinnquote',
  'settings.statsHiddenTag': 'Statistik ausgeblendet',
  'settings.name': 'Name am Tisch',
  'settings.nameChanged': 'Name geändert',
  'settings.save': 'Speichern',
  'settings.nameNote': 'In vergangenen Spielen bleibt der Name erhalten, unter dem Sie gespielt haben.',
  'settings.changePassword': 'Passwort ändern',
  'settings.setPassword': 'Anmeldung mit Benutzername und Passwort',
  'settings.passwordMismatch': 'Passwörter stimmen nicht überein',
  'settings.passwordSaved': 'Passwort gespeichert',
  'settings.login': 'Benutzername',
  'settings.currentPassword': 'Aktuelles Passwort',
  'settings.newPassword': 'Neues Passwort',
  'settings.newPasswordAgain': 'Neues Passwort wiederholen',
  'settings.savePassword': 'Passwort speichern',
  'settings.providers': 'Anmeldung über Dienste',
  'settings.noProviders': 'Die Anmeldung über externe Dienste ist auf dem Server nicht eingerichtet.',
  'settings.linkedSince': 'seit {date}',
  'settings.unlinked': 'Dienst getrennt',
  'settings.unlink': 'Trennen',
  'settings.notLinked': 'nicht verknüpft',
  'settings.link': 'Verknüpfen',

  'reset.button': 'Guthaben zurücksetzen',
  'reset.already': 'das Guthaben entspricht bereits dem Startwert',
  'reset.title': 'Guthaben zurücksetzen',
  'reset.titleFor': 'Guthaben zurücksetzen: {name}',
  'reset.confirm': 'Auf {amount|cr} zurücksetzen',
  'reset.textBefore': 'Das Guthaben wird auf',
  'reset.textNow': 'gesetzt (aktuell',
  'reset.textAfter': '). Statistik und Spielverlauf bleiben erhalten. Während eines Spiels ist das Zurücksetzen nicht möglich.',
  'reset.done': 'Guthaben zurückgesetzt: {amount|cr}',

  'kind.market': 'Markt',
  'kind.walkover': 'nur einer übrig',
  'kind.cancel': 'Abbruch',
  'games.emptyPlayer': 'Noch keine Spiele — setzen Sie sich in der Lobby an einen Tisch.',
  'games.emptyAdmin': 'Es gab noch keine Spiele.',
  'games.historyTag': 'Historie',
  'games.error': 'Fehler {v}',
  'games.replay': 'Spielverlauf',
  'col.time': 'Zeit',
  'col.table': 'Tisch',
  'col.composition': 'Zusammensetzung',
  'col.forecast': 'Prognose',
  'col.contributed': 'Eingezahlt',
  'col.net': 'Nettoergebnis',
  'col.players': 'Spieler',
  'col.pot': 'Pot',
  'col.commission': 'Kommission',
  'col.player': 'Spieler',
  'col.error': 'Fehler',
  'col.payout': 'Auszahlung',

  'replay.loading': 'Spielaufzeichnung wird geladen…',
  'replay.crumbAdmin': 'Alle Spiele',
  'replay.crumbProfile': 'Profil',
  'replay.crumbGame': 'Spiel {id}',
  'replay.title': 'Tisch {ante|cr} · {date}',
  'replay.modeReplay': 'historische Wiedergabe',
  'replay.modeLive': 'live',
  'replay.sourceSynthetic': 'synthetische Daten',
  'replay.seats': '{n} Teilnehmer|{n} Teilnehmer',
  'replay.result': 'Ausgang',
  'replay.resultCancelled': 'abgebrochen',
  'replay.resultWalkover': 'nur einer übrig',
  'replay.resultSettled': 'Abrechnung',
  'replay.pot': 'Pot',
  'replay.legacy': 'Die Aufzeichnung wurde aus dem Protokoll einer früheren Version übernommen: Zugverlauf und Chart wurden nicht gespeichert, nur die Abrechnung ist verfügbar.',
  'replay.toStart': 'Zum Anfang',
  'replay.stepBack': 'Schritt zurück',
  'replay.pause': 'Pause',
  'replay.play': 'Abspielen',
  'replay.stepForward': 'Schritt vor',
  'replay.toEnd': 'Zum Ende',
  'replay.position': 'Zeitpunkt der Aufzeichnung',
  'replay.stageSettled': 'Abrechnung abgeschlossen',
  'replay.stagePrep': 'Vorbereitung: Antes werden in den Pot eingezahlt',
  'replay.participants': 'Teilnehmer',
  'replay.you': 'Sie',
  'replay.returned': 'zurück {amount}',
  'replay.noteNet': 'Rechts — Nettoergebnis.',
  'replay.noteContributed': 'Rechts — bis zu diesem Zeitpunkt in den Pot eingezahlt.',
  'replay.noteAdmin': 'Prognosen sind für den Administrator sichtbar.',
  'replay.notePlayer': 'Prognosen anderer Spieler sind in der Abrechnung sichtbar.',
  'replay.composition': 'Zusammensetzung',
  'replay.compositionHidden': 'wird in Runde 3 aufgedeckt',
  'replay.timeline': 'Verlauf',
  'replay.settlement': 'Abrechnung',
  'replay.summary': 'P₀ {p0} → P₁ {p1}; Kommission {commission|cr}.',
  'replay.verify': 'Im Browser prüfen',
  'replay.download': 'Prüfpaket herunterladen',
  'replay.roundPrep': 'Vorbereitung',
  'replay.round': 'Runde {n}',
  // ── проверка файла пакета (перенесена из лобби в 0.8.2) ──
  'verify.title': 'Spielprüfung',
  'verify.textBefore':
    'Nach jedem Spiel kann ein Teilnehmer ein signiertes Paket herunterladen: alle Züge, die Zusammensetzung und die Ausgangskurse der Aktien, die Abrechnung und die Buchungen. Sie können es hier prüfen oder mit dem Werkzeug',
  'verify.textAfter': 'und die Kurse mit einer beliebigen externen Quelle vergleichen.',
  'verify.button': 'Paketdatei prüfen…',
};
